import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
  inject,
  input,
} from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { PrimeButtonComponent } from '../../../../base-components';

@Component({
  selector: 'prime-simple-yes-no-footer',
  imports: [PrimeButtonComponent, AsyncPipe],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './simple-yes-no-footer.component.html',
})
export class SimpleYesNoFooterComponent {
  private readonly dialogRef = inject(DynamicDialogRef, { optional: true });

  confirmButtonDisabled$: Observable<boolean>;
  readonly cancelButtonLabel = input<string>('No');
  readonly confirmButtonLabel = input<string>('Yes');
  readonly closeOnCancel = input<boolean>(true);
  readonly justifyPosition = input<'start' | 'end' | 'between'>('between');
  @Output() onCancel: EventEmitter<void>;
  @Output() onConfirm: EventEmitter<void>;

  @Input() set confirmButtonDisabledStreamManager(stream$: Observable<boolean> | null) {
    if (stream$) {
      this.confirmButtonDisabled$ = stream$;
    }
  }

  constructor() {
    this.onCancel = new EventEmitter<void>();
    this.onConfirm = new EventEmitter<void>();
    this.confirmButtonDisabled$ = new BehaviorSubject<boolean>(false).asObservable();
  }

  noClickHandler(): void {
    this.closeOnCancel() && this.dialogRef?.close();
    this.onCancel.emit(undefined);
  }

  yesClickHandler(): void {
    this.onConfirm.emit(undefined);
  }
}
